import request from '@/utils/request'

// 查询安置点列表
export function listAzd(query) {
  return request({
    url: '/hhgl/azd/list',
    method: 'get',
    params: query
  })
}

// 查询安置点详细
export function getAzd(id) {
  return request({
    url: '/hhgl/azd/' + id,
    method: 'get'
  })
}

// 新增安置点
export function addAzd(data) {
  return request({
    url: '/hhgl/azd',
    method: 'post',
    data: data
  })
}

// 修改安置点
export function updateAzd(data) {
  return request({
    url: '/hhgl/azd',
    method: 'put',
    data: data
  })
}

// 删除安置点
export function delAzd(id) {
  return request({
    url: '/hhgl/azd/' + id,
    method: 'delete'
  })
}
